import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetOptOutScreenDetailsRPC } from "./getOptOutScreenDetailsRPC";

export class GetOptOutScreenDetailsRPCClientImpl extends GetOptOutScreenDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetOptOutScreenDetailsRPC.Request): Promise<LeoRPCResult<GetOptOutScreenDetailsRPC.Response, GetOptOutScreenDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetOptOutScreenDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetOptOutScreenDetailsRPC.ResponseDTO,
      GetOptOutScreenDetailsRPC.Errors.ErrorsDTO,
      GetOptOutScreenDetailsRPC.Response,
      GetOptOutScreenDetailsRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetOptOutScreenDetails",
      GetOptOutScreenDetailsRPC.Response.fromDTO,
      GetOptOutScreenDetailsRPC.Errors.fromDTO
    );
  }
}
